<template>
    <div>
        <div
            v-show="!errors.google"
            class="flex justify-center pb-3"
            id="googleSignIn"
        ></div>
        <div
            class="flex justify-center error--text text-sm mb-6"
            v-if="errors.google"
        >
            {{ errors.google }}
        </div>
        <div v-if="divider && !errors.google" class="mt-3">
            <v-divider class="mx-auto" inset />
            <div
                class="flex justify-center"
                style="transform: translateY(-13px)"
            >
                <v-sheet class="w-10 white"
                    ><div class="font-bold soli-grey flex justify-center">
                        or
                    </div></v-sheet
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errors: {},
        register: {
            type: Boolean,
            default: false,
        },
        divider: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        handleCredentialResponse(response) {
            this.$inertia.post("/google/oauth", {
                token: response.credential,
                remember: true,
                register: this.register,
                onSuccess: (resp) => {
                    console.log(resp);
                },
            });
        },
        createGoogleLogin() {
            let googleAuthScript = document.createElement("script");
            googleAuthScript.setAttribute(
                "src",
                "https://accounts.google.com/gsi/client"
            );
            document.head.appendChild(googleAuthScript);

            // render google login button
            const clientId = window.location.href.includes("musicologie.app")
                ? "638179707569-qurekcejldl1581s3iie2r3plk1sqooj.apps.googleusercontent.com"
                : "913942240028-2fnj67d0a8h6mhn7j5q8vaged5m6pgf2.apps.googleusercontent.com";

            this.loadGoogleLogin(clientId);
        },
        loadGoogleLogin(clientId) {
            // import/load google gsi client
            window.onload = () => {
                google.accounts.id.initialize({
                    client_id: clientId,
                    callback: this.handleCredentialResponse,
                });

                google.accounts.id.renderButton(
                    document.getElementById("googleSignIn"),
                    {
                        theme: "outline",
                        size: "medium",
                        text: this.register ? "signup_with" : "continue_withS",
                        shape: "pill",
                    }
                );
            };
        },
    },
    mounted() {
        this.createGoogleLogin();
    },
};
</script>
